import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/iview.js'

import '@/styles/base.scss' // 基础样式
import '@/router/router_setting' // 路由设置

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
